import React from 'react'
import Tooltip from 'rc-tooltip'
import styled from 'styled-components'
import { WidgetProps } from '@rjsf/utils'

import { useBotFlow } from '../../../../../../store/flow'
import { useAccessLevel } from '../../../../../../store/user'

export const CampaignControlWidget: React.FC<WidgetProps> = ({
  id,
  value: campaignId,
  onChange
}) => {
  const flow = useBotFlow()
  const { callsList: canAccessCallsList } = useAccessLevel()

  const disabled = !campaignId
  const relativeLink = `/bots/${flow!.id}/campaigns/${campaignId}`

  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: 'calc(80% - 26px)'
      }}
    >
      <input
        id={id}
        value={campaignId}
        style={{ flex: 3 }}
        data-test="campaign-id"
        className="form-control"
        onChange={event => onChange(event.target.value)}
      />
      {canAccessCallsList && (
        <Tooltip
          placement="top"
          mouseEnterDelay={0.3}
          overlayStyle={{ maxWidth: 250 }}
          overlay={
            <span>
              {disabled
                ? 'Please type campaign ID.'
                : `Warning, you will be redirect to new tab page for editing and adding campaign contacts, if you don't save changes in this campaign section not all data will be presented.`}
            </span>
          }
        >
          <span>
            <Link
              key={2}
              target="_blank"
              $disabled={disabled}
              rel="noopener noreferrer"
              className="btn btn-default"
              href={relativeLink}
              style={{ marginLeft: 12 }}
              title="Opens the new tab with campaigns"
            >
              Add contacts
            </Link>
          </span>
        </Tooltip>
      )}
    </span>
  )
}

const Link = styled.a<{ $disabled: boolean }>`
  cursor: ${props => (props.$disabled ? 'default' : 'pointer')};
  pointer-events: ${props => (props.$disabled ? 'none' : 'auto')};
  background-color: ${props => (props.$disabled ? ' #e9edf1' : 'inherit')};
`
